export default "__VITE_ASSET__49ZhD3xN__"